import { images } from "../../Components/BlogLogic/BlogLogic";
import { useNavigate } from "react-router-dom";
import React, { useEffect, useState } from "react";
import { getBlogs } from "../../../../services/blog";
import Testimonial from "../Testimonials/Testimonial";
import { blogBg } from "../../../../../images";
import SEO from "../../../../SEO/Seo";
import { metaContent } from "../../../../SEO/metaContent";

const Blog = () => {
  const navigate = useNavigate();

  const [blogs, setBlogs] = useState([]);

  useEffect(() => {
    fetchBlogs();

    // Select the static container
    const staticContainer = document.querySelector(".static-container");
    if (!staticContainer) return;

    const oldBackground = staticContainer.style.backgroundImage;
    const oldBgColor = staticContainer.style.backgroundColor;
    const oldBgSize = staticContainer.style.backgroundSize;
    const oldBgRepeat = staticContainer.style.backgroundRepeat;
    const oldBgPosition = staticContainer.style.backgroundPosition;
    const oldBgAttachment = staticContainer.style.backgroundAttachment;

    staticContainer.style.backgroundImage = `url(${blogBg})`;
    staticContainer.style.backgroundSize = "cover";
    staticContainer.style.backgroundRepeat = "no-repeat";
    staticContainer.style.backgroundPosition = "center";
    staticContainer.style.transition = "background 0.5s ease-in-out";

    return () => {
      staticContainer.style.backgroundImage = oldBackground;
      staticContainer.style.backgroundColor = oldBgColor;
      staticContainer.style.backgroundSize = oldBgSize;
      staticContainer.style.backgroundRepeat = oldBgRepeat;
      staticContainer.style.backgroundPosition = oldBgPosition;
      staticContainer.style.backgroundAttachment = oldBgAttachment;
    };
  }, []);

  const fetchBlogs = async () => {
    try {
      const response = await getBlogs();
      console.log("DEBUG: Blog API Response:", response); 
      
      // Defensively handle different response shapes
      if (Array.isArray(response)) {
        setBlogs(response);
      } else if (response?.data && Array.isArray(response.data)) {
        setBlogs(response.data);
      } else if (response?.success && Array.isArray(response.data)) {
        setBlogs(response.data);
      } else {
        console.warn("DEBUG: Unrecognized response shape", response);
        setBlogs([]);
      }
    } catch (error) {
      console.error("Error fetching blogs:", error);
    }
  };

  return (
    <>
      <SEO {...metaContent.blog} />

      <div className="blog-container">
        <div className="text-center">
          <h2 className="hero-heading gradient-text">Knowledge</h2>
          <p className="hero-heading text-white">That Drives Growth.</p>
          <p className="hero-sub-text">
            Our experts share proven insights, tips, and strategies to help
            sellers and brands scale smarter and faster.
          </p>
        </div>

        <div className="blog-grid-div">
          <div className="row g-5 mt-5">
            {blogs?.map((blog) => (
              <div
                key={blog.id}
                className={`col-md-4 ${
                  blog.id === "1" ? "with-overlay" : ""
                }`}
              >
                <div className="blog-card h-100">
                  <img
                    src={blog.featured_image}
                    alt={blog.title}
                    className="blog-img img-fluid"
                    style={{
                      width: "100%",
                      height: "180px",
                      objectFit: "cover",
                      borderRadius: "16px"
                    }}
                  />

                  <div className="mt-2 mb-5">
                    <span className="blog-date">
                      {blog.published_at || "Nov 01, 2022"}
                    </span>

                    <h3 
                      className="blog-title"
                      style={{
                        display: "-webkit-box",
                        WebkitLineClamp: 3,
                        WebkitBoxOrient: "vertical",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                      }}
                    >
                      {blog.title}
                    </h3>

                    <p 
                      className="blog-content"
                      style={{
                        display: "-webkit-box",
                        WebkitLineClamp: 5,
                        WebkitBoxOrient: "vertical",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                      }}
                    >
                      {blog.short_description}
                    </p>

                    <button
                      className="learn-more-btn text-center mt-1"
                      onClick={() =>
                        navigate(`/blog-details/${blog.id}`)
                      }
                    >
                      Read More
                    </button>
                  </div>
                </div>
              </div>
            ))}

            {blogs.length === 0 && (
              <div className="col-12 text-center">
                <p className="text-white">No blogs available.</p>
              </div>
            )}
          </div>
        </div>
      </div>

      <Testimonial />
    </>
  );
};

export default Blog;